import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { handleApiError } from '../../utils/errorHandler';

const ClassesTab = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadClasses();
  }, []);

  const loadClasses = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/subjects');
      setClasses(response.data);
    } catch (err) {
      console.error('Error loading classes:', err);
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: '1.5rem' }}>All School Classes</h2>
      {loading ? (
        <div className="loading">Loading classes...</div>
      ) : classes.length > 0 ? (
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
          gap: '1.5rem' 
        }}>
          {classes.map((classItem) => (
            <div key={classItem.id} style={{
              background: 'white',
              padding: '1.5rem',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: classItem.is_system ? '2px solid #667eea' : '1px solid #e2e8f0'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                {classItem.emoji && <span style={{ fontSize: '2rem' }}>{classItem.emoji}</span>}
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>
                    {classItem.translations?.[0]?.name || classItem.key}
                  </h3>
                  {classItem.is_system ? (
                    <span style={{ fontSize: '0.75rem', color: '#667eea', fontWeight: 600 }}>System Class</span>
                  ) : classItem.created_by_user_id && (
                    <span style={{ fontSize: '0.75rem', color: '#667eea', fontWeight: 600 }}>Custom Class</span>
                  )}
                </div>
              </div>
              <div style={{ fontSize: '0.85rem', color: '#718096' }}>
                <div>Key: {classItem.key}</div>
                <div>Active: {classItem.is_active ? 'Yes' : 'No'}</div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>No classes found.</p>
        </div>
      )}
    </div>
  );
};

export default ClassesTab;

